















import { Component, Prop, Vue } from "vue-property-decorator";
import HomeSection from "../home/HomeSection.vue";

@Component({
  components: { HomeSection },
})
export default class ProgramPage extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) backTo!: string;
  @Prop({ type: String, default: "" }) backLabel!: string;
  @Prop({ type: String, default: "" }) empty!: string;
}
